import type { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import BackToTop from "./BackToTop";
import MarqueeBar from "./MarqueeBar";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="w-full min-h-screen flex flex-col bg-background-50">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 w-full">{children}</main>
      <MarqueeBar />
      <Footer />
      <BackToTop />
    </div>
  );
}